import { render, staticRenderFns } from "./InvoicesBillingStats.vue?vue&type=template&id=79297976"
import script from "./InvoicesBillingStats.vue?vue&type=script&lang=ts"
export * from "./InvoicesBillingStats.vue?vue&type=script&lang=ts"
import style0 from "./InvoicesBillingStats.vue?vue&type=style&index=0&id=79297976&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports